module.exports = __webpack_public_path__ + "static/media/megaport.9773293e.svg";